
import styles from './listing_content.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Media from './basic/media'
import Button from './basic/button'

function ListingContent(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={styles.listing_content}>
		<ScrollAnimation styles={styles}>
			<div className={styles.listing_wrapper}>
				{fields.list_items.map((feature, i) => {
					return <div key={i} className={styles.list_item_wrapper}>
						<div className={styles.media}>
							<Media {...feature.media} settings={{texture: true}} className={styles.media} />
						</div>
						<div className={styles.content_wrapper}>
							<h3>{feature.title}</h3>
							<div className={styles.content} dangerouslySetInnerHTML={{__html: feature.content}}></div>
							{feature.link.title &&
								<Button fields={{button: feature.link}} color='green' className={styles.button}>{feature.link.title}</Button>
							}
						</div>
					</div>
				})}
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default ListingContent